import { KyInstance } from 'ky';
import qs from 'qs';

import { SupportTicketSubject } from './support-ticket-subject.model';
import { CommonQueryParams, CommonResponse } from '../common';

export async function getSupportTicketSubjects(
  httpClient: KyInstance,
  options: CommonQueryParams,
): Promise<CommonResponse<SupportTicketSubject>> {
  const searchParams = qs.stringify(options);

  return await httpClient.get('support-ticket-subjects', { searchParams }).json();
}
